import gql from 'graphql-tag';

export default gql`
mutation AddEndpoint(
        $app: String!,
        $name: String!,
        $desc: String!,
        $images: String,
        $tag1: String,
        $tag2: String,
        $tag3: String,
        $tag4: String,
        $tag5: String
        ) {
    createEndpoint(input:{
        app: $app,
        name: $name,
        desc: $desc,
        images: $images,
        tag1: $tag1,
        tag2: $tag2,
        tag3: $tag3,
        tag4: $tag4,
        tag5: $tag5
    }) {
        __typename
        uuid
    }
}
`;
